import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WavyDivider } from '../components/WavyDivider';
import { ServiceCard } from '../components/ServiceCard';
import { servicesData } from '../data/services';
import { useSeo } from '../lib/useSeo';
export function Services() {
  useSeo({
    title: 'Services & Offerings',
    description: 'Explore our offerings including Meditation Between Worlds, Sound-Infused Renewal, and intuitive guidance sessions to help you find balance.',
    path: '/services',
    image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&q=80'
  });
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-492">
      <Header data-id="element-493" />

      {/* Hero Section */}
      <section className="relative h-[65vh] min-h-[480px] flex items-center justify-center overflow-hidden" data-id="element-494">
        <div className="absolute inset-0 z-0" data-id="element-495">
          <img src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&q=80" alt="Misty forest landscape" className="w-full h-full object-cover" data-id="element-496" />
          <div className="absolute inset-0 bg-charcoal/30" data-id="element-497"></div>
        </div>

        <div className="relative z-10 text-center px-6 mt-16" data-id="element-498">
          <h1 className="text-5xl md:text-7xl font-serif text-white mb-4 drop-shadow-md" data-id="element-499">
            My services
          </h1>
          <p className="text-xl md:text-2xl text-white/90 font-serif italic drop-shadow-md" data-id="element-500">
            Gentle spaces for healing, presence, and returning to your center.
          </p>
        </div>

        <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none" data-id="element-501">
          <WavyDivider fill="#F8F2E4" data-id="element-502" />
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 px-6 bg-cream" data-id="element-503">
        <div className="max-w-3xl mx-auto text-center" data-id="element-504">
          <p className="text-xl md:text-2xl font-serif italic text-sage-700 mb-8 leading-relaxed" data-id="element-505">
            "In the quiet spaces between our thoughts, the soul speaks its
            truest language."
          </p>
          <p className="text-charcoal-50 font-light leading-relaxed" data-id="element-506">
            Your Transformation (better health, more joy & peace of mind) My
            Soul Garden is a space of presence, sound, and renewal. A place
            where vibrations meet silence, and where transformation happens
            gently, in your own rhythm.
          </p>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="py-20 px-6 bg-cream pb-32" data-id="element-507">
        <div className="max-w-7xl mx-auto" data-id="element-508">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-509">
            {servicesData.map(service => <ServiceCard key={service.id} {...service} data-id="element-510" />)}
          </div>
        </div>
      </section>

      {/* Closing Section */}
      <section className="relative bg-sage-50 pt-32 pb-20 px-6 mt-20" data-id="element-511">
        <div className="absolute top-0 left-0 right-0 -translate-y-full pointer-events-none" data-id="element-512">
          <WavyDivider fill="#E8EFE7" position="top" data-id="element-513" />
        </div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-514">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-8" data-id="element-515">
            What to Expect
          </h2>
          <p className="text-charcoal-50 font-light leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-516">
            Every session is held with deep respect for your personal boundaries
            and current state of being. There is no right or wrong way to
            experience this work. Come exactly as you are.
          </p>
          <img src="https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?auto=format&fit=crop&q=80" alt="Soft nature detail" className="w-full max-w-2xl mx-auto h-64 object-cover rounded-2xl shadow-soft" data-id="element-517" />
        </div>
      </section>

      <Footer data-id="element-518" />
    </div>;
}